import { render } from "./PWABanner.vue?vue&type=template&id=47334598"
import script from "./PWABanner.vue?vue&type=script&lang=js"
export * from "./PWABanner.vue?vue&type=script&lang=js"

import "./PWABanner.vue?vue&type=style&index=0&id=47334598&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__